/**
 * Filtros client-side sobre linhas de sumarizacao_esocial (comp × rubrica).
 */

function competenciaYm(competencia) {
  if (!competencia || String(competencia).length < 7) return "";
  return String(competencia).slice(0, 7);
}

/** Intervalo YYYY-MM das competências presentes nas linhas. */
export function competenciaRangeFromLinhasEsocial(linhas) {
  let min = "";
  let max = "";
  for (const linha of linhas || []) {
    const ym = competenciaYm(linha.competencia);
    if (!ym) continue;
    if (!min || ym < min) min = ym;
    if (!max || ym > max) max = ym;
  }
  return { min, max };
}

function matchSimNao(filtro, valorBool) {
  const f = String(filtro || "")
    .trim()
    .toLowerCase();
  if (!f) return true;
  if (f === "sim") return Boolean(valorBool);
  if (f === "nao" || f === "não") return !valorBool;
  return true;
}

/**
 * Valor do filtro de base legal que seleciona as linhas SEM base legal — cobre o que o
 * antigo filtro `compoeProjeto = 'nao'` fazia. Espelha o sentinela da api-relatorios.
 */
export const SEM_BASE_LEGAL = "sem";

function matchBaseLegal(selecionadas, baseLegalId) {
  const sel = Array.isArray(selecionadas)
    ? selecionadas.map((c) => String(c).trim()).filter(Boolean)
    : null;
  if (sel === null || sel.length === 0) return true;
  const cod = baseLegalId == null ? SEM_BASE_LEGAL : String(baseLegalId);
  return sel.includes(cod);
}

/**
 * @param {Array<object>} linhas
 * @param {object} filtros
 * @param {string} [filtros.competenciaInicio] YYYY-MM
 * @param {string} [filtros.competenciaFim] YYYY-MM
 * @param {string} [filtros.codigoRubrica]
 * @param {string} [filtros.buscaRubrica] descrição / tipo parcial
 * @param {string} [filtros.tipoRubrica]
 * @param {string[]} [filtros.baseLegalSelecionadas] códigos de base legal selecionados (id ou SEM_BASE_LEGAL); vazio/ausente = todas
 * @param {string} [filtros.flagIncidencia] '' | 'sim' | 'nao'
 * @param {string} [filtros.verbaFerias] '' | 'sim' | 'nao'
 */
export function filtrarLinhasEsocialAgrupado(linhas, filtros = {}) {
  const lista = Array.isArray(linhas) ? linhas : [];
  const ini = String(filtros.competenciaInicio || "").trim();
  const fim = String(filtros.competenciaFim || "").trim();
  const codigo = String(filtros.codigoRubrica || "").trim();
  const busca = String(filtros.buscaRubrica || "")
    .trim()
    .toLowerCase();
  const tipo = String(filtros.tipoRubrica || "").trim().toLowerCase();

  return lista.filter((linha) => {
    const ym = competenciaYm(linha.competencia);
    if (ini && ym && ym < ini) return false;
    if (fim && ym && ym > fim) return false;

    if (codigo) {
      const cod = String(linha.codigoRubrica || "");
      if (!cod.includes(codigo)) return false;
    }

    if (busca) {
      const texto = `${linha.descricaoRubrica || ""} ${linha.tipoRubrica || ""}`.toLowerCase();
      if (!texto.includes(busca)) return false;
    }

    if (tipo) {
      if (String(linha.tipoRubrica || "").toLowerCase() !== tipo) return false;
    }

    if (!matchBaseLegal(filtros.baseLegalSelecionadas, linha.baseLegalId)) return false;
    if (!matchSimNao(filtros.flagIncidencia, linha.flagIncidencia)) return false;
    if (!matchSimNao(filtros.verbaFerias, linha.verbaFerias)) return false;

    return true;
  });
}

/**
 * @param {Array<object>} linhas
 * @param {number} pagina 1-based
 * @param {number} limite
 */
export function paginarLinhas(linhas, pagina, limite) {
  const lista = Array.isArray(linhas) ? linhas : [];
  const lim = Math.max(1, Number(limite) || 10);
  const total = lista.length;
  const totalPaginas = total > 0 ? Math.ceil(total / lim) : 0;
  const pag = Math.min(Math.max(1, Number(pagina) || 1), Math.max(1, totalPaginas || 1));
  const inicio = (pag - 1) * lim;
  return {
    linhas: lista.slice(inicio, inicio + lim),
    paginacao: { pagina: pag, limite: lim, total, totalPaginas },
  };
}

/** Tipos distintos presentes nas linhas (para select de filtro). */
export function tiposRubricaFromLinhas(linhas) {
  const set = new Set();
  for (const l of linhas || []) {
    const t = String(l?.tipoRubrica || "").trim();
    if (t) set.add(t);
  }
  return Array.from(set).sort((a, b) => a.localeCompare(b, "pt-BR"));
}
